import { liveData } from "../types/live.interface";
import { GetterTree, MutationTree, ActionTree } from "vuex";

const state: liveData = {
	isLoading: true,
	isPlaying: false,
	hasAudio: false,
	audioErr: "",
};

const getters: GetterTree<liveData, any> = {};

const mutations: MutationTree<liveData> = {
	UPDATE_ISLOADING(state: liveData, status: boolean) {
		state.isLoading = status;
	},
	UPDATE_ISPLAYING(state: liveData, status: boolean) {
		state.isPlaying = status;
	},
	UPDATE_AUDIOERR(state: liveData, tips = "") {
		state.audioErr = tips;
	},
	UPDATE_HASAUDIO(state: liveData, status: boolean) {
		state.hasAudio = status;
	},
};

const actions: ActionTree<liveData, any> = {};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
